export default __webpack_public_path__ + "static/Group 82-52961d258f408124741cf20659ce513c.jpg";